const ErrorMessage = ({ message }: { message: string }) => {
  return (
    <span className="text-red-500 text-xs font-bold mr-6 p-1">{message}</span>
  );
};

export default ErrorMessage;
